import { defineComponent as _defineComponent } from 'vue'
import router from '@/router/router';
import authenticationService from '@/core/services/account/authentication.service';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavigation',
  setup(__props) {

const isAuthenticated = computed(() => authenticationService.context.isAuthenticated);

function signOut(): void {
    authenticationService.signOut();
    router.push({ name: 'login' });
}

return { __sfc: true,isAuthenticated, signOut }
}

})